import { IOpportunities } from '../models/service/service';
import { isActiveOpp, isExpiredOpp } from './methods';

export const filterOpportunities = (tabs: number, opportunities: IOpportunities[]) => {
  const activeOpp = [...opportunities].sort((a, b) => {
    const dateA = new Date(a.startDate).getTime();
    const dateB = new Date(b.startDate).getTime();
    return dateA - dateB;
  });
  if (tabs === 0) {
    const filteredOpp = activeOpp.filter((item: IOpportunities) => isActiveOpp(item));
    return filteredOpp;
  }
  if (tabs === 1) {
    const filteredOpp = activeOpp.filter((item: IOpportunities) => isExpiredOpp(item.endDate, item.frequency[0]));
    return filteredOpp;
  }
  return activeOpp;
};
